module.exports = __webpack_public_path__ + "assets/img/bc09-cg.svg";